import _extends from '@babel/runtime/helpers/extends';
import _jsx from '@babel/runtime/helpers/jsx';
import React, { useState, useMemo } from 'react';
import 'prop-types';
import { StyledLabel } from '@vpp-frontend-components/styled-label';
import { useVppContext } from '@vpp-frontend-components/vpp-context';
import { Card, PolycardContext } from '@polycard/card';
import { Icons, getIcons } from '@polycard/icons';
import { Icon } from '@vpp-frontend-components/icon';
import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import { getFormattedIntFraction, PriceDesktop, jsonToProps } from '@vpp-frontend-components/price';
import { MoneyAmount } from '@andes/money-amount';
import classnames from 'classnames';
import { useTrackView } from '@vpp-frontend-components/hooks';
const kitsConstants = {
  PRICE_LIST_FONT_SIZE: 20
};
const setPolycardListPriceSize = (cardItem, PRICE_LIST_FONT_SIZE) => {
  var _findPrice$price;
  const findPrice = cardItem.components.find(key => key.type === 'price');
  const currentPrice = findPrice === null || findPrice === void 0 || (_findPrice$price = findPrice.price) === null || _findPrice$price === void 0 ? void 0 : _findPrice$price.current_price;
  const hasSizeProperty = Object.prototype.hasOwnProperty.call(currentPrice, 'size');
  if (!hasSizeProperty) {
    currentPrice.size = PRICE_LIST_FONT_SIZE;
  }
  return cardItem;
};
const KitsMapListDesktop = _ref => {
  let {
    list = []
  } = _ref;
  const {
    PRICE_LIST_FONT_SIZE
  } = kitsConstants;
  const getKeyValue = id => `kit-list-${id}`;
  return list === null || list === void 0 ? void 0 : list.map(polycard => {
    var _polycardItem$metadat;
    const polycardItem = setPolycardListPriceSize(polycard, PRICE_LIST_FONT_SIZE);
    return /*#__PURE__*/_jsx("div", {
      className: "ui-pdp-kits-list__item"
    }, getKeyValue(polycardItem === null || polycardItem === void 0 || (_polycardItem$metadat = polycardItem.metadata) === null || _polycardItem$metadat === void 0 ? void 0 : _polycardItem$metadat.id), /*#__PURE__*/_jsx(Card, {
      polycard: polycardItem
    }));
  });
};
const KitsListDesktop = _ref => {
  let {
    children = null,
    title,
    subtitle,
    polycards,
    polycard_context,
    runCatchErrorBoundary = () => {}
  } = _ref;
  try {
    /* eslint-disable react-hooks/rules-of-hooks */
    const [polycardList, setPolycardList] = useState([]);
    const {
      staticProps
    } = useVppContext();
    const {
      country,
      deviceType
    } = staticProps;
    useMemo(() => {
      setPolycardList(polycards);
    }, [polycards]);
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/_jsx(Icons, {
      icons: getIcons()
    }), /*#__PURE__*/React.createElement(StyledLabel, _extends({
      className: "ui-pdp-kits-title"
    }, title)), /*#__PURE__*/React.createElement(StyledLabel, _extends({
      className: "ui-pdp-kits-subtitle"
    }, subtitle)), /*#__PURE__*/_jsx("div", {
      className: "ui-pdp-kits-list"
    }, void 0, /*#__PURE__*/_jsx(PolycardContext, {
      contextValue: polycard_context,
      deviceType: deviceType,
      thousandSeparator: country.thousands_separator,
      decimalSeparator: country.decimal_separator
    }, void 0, /*#__PURE__*/_jsx(KitsMapListDesktop, {
      list: polycardList
    })), children));
    /* eslint-enable react-hooks/rules-of-hooks */
  } catch (error) {
    /* istanbul ignore next */
    return runCatchErrorBoundary(error);
  }
};
var _Icon;
const KitsMapListMobile = _ref => {
  let {
    list = []
  } = _ref;
  const getKeyValue = id => `kit-list-${id}`;
  return list === null || list === void 0 ? void 0 : list.map(polycard => {
    var _polycard$metadata;
    return /*#__PURE__*/_jsx("div", {
      className: "ui-pdp-kits-list__item"
    }, getKeyValue(polycard === null || polycard === void 0 || (_polycard$metadata = polycard.metadata) === null || _polycard$metadata === void 0 ? void 0 : _polycard$metadata.id), /*#__PURE__*/_jsx(Card, {
      polycard: polycard
    }), _Icon || (_Icon = /*#__PURE__*/_jsx(Icon, {
      id: "chevron",
      className: "ui-pdp-kits-list__chevron"
    })));
  });
};
const KitsListMobile = _ref => {
  let {
    children = null,
    title,
    subtitle,
    polycards,
    polycard_context
  } = _ref;
  const [polycardList, setPolycardList] = useState([]);
  const {
    staticProps
  } = useVppContext();
  const {
    country,
    deviceType
  } = staticProps;
  useMemo(() => {
    setPolycardList(polycards);
  }, [polycards]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/_jsx(Icons, {
    icons: getIcons()
  }), /*#__PURE__*/React.createElement(StyledLabel, _extends({}, title, {
    className: "ui-pdp-kits__title"
  })), /*#__PURE__*/React.createElement(StyledLabel, _extends({}, subtitle, {
    className: "ui-pdp-kits__subtitle"
  })), /*#__PURE__*/_jsx("div", {
    className: "ui-pdp-kits-list flexible-layout"
  }, void 0, /*#__PURE__*/_jsx(PolycardContext, {
    contextValue: polycard_context,
    deviceType: deviceType,
    thousandSeparator: country.thousands_separator,
    decimalSeparator: country.decimal_separator
  }, void 0, /*#__PURE__*/_jsx(KitsMapListMobile, {
    list: polycardList
  }))), children);
};
const _excluded$1 = ["current_price_label", "total_price_label", "price", "runCatchErrorBoundary"];
const KitsPriceDesktop = _ref => {
  let {
      current_price_label = {},
      total_price_label = {},
      price = {},
      runCatchErrorBoundary = () => {}
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded$1);
  try {
    /* eslint-disable react-hooks/rules-of-hooks */
    const {
      staticProps
    } = useVppContext();
    const {
      country: {
        thousands_separator: thousandSeparator
      }
    } = staticProps;
    const intFraction = getFormattedIntFraction(price.original_value, thousandSeparator);
    const priceProps = _objectSpread({
      price: _objectSpread(_objectSpread({}, price), {}, {
        original_value: null
      })
    }, props);
    return /*#__PURE__*/_jsx("div", {
      className: "ui-pdp-kits-price"
    }, void 0, Object.keys(current_price_label).length > 0 && (price === null || price === void 0 ? void 0 : price.original_value) && /*#__PURE__*/_jsx("div", {
      className: "ui-pdp-price-discount"
    }, void 0, /*#__PURE__*/React.createElement(StyledLabel, current_price_label), /*#__PURE__*/_jsx(MoneyAmount, {
      previous: true,
      symbol: price.currency_symbol,
      size: 18,
      value: {
        fraction: intFraction
      }
    })), /*#__PURE__*/_jsx("div", {
      className: "ui-pdp-price-total"
    }, void 0, /*#__PURE__*/React.createElement(StyledLabel, _extends({}, total_price_label, {
      className: "ui-pdp-price-total__text"
    })), /*#__PURE__*/React.createElement(PriceDesktop, _extends({
      meta: true,
      num_font_size: 24
    }, jsonToProps(priceProps)))));
    /* eslint-enable react-hooks/rules-of-hooks */
  } catch (error) {
    /* istanbul ignore next */
    return runCatchErrorBoundary(error);
  }
};
const _excluded = ["current_price_label", "total_price_label", "price"];
const KitsPriceMobile = _ref => {
  let {
      current_price_label = {},
      total_price_label = {},
      price = {}
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const {
    staticProps
  } = useVppContext();
  const {
    country: {
      thousands_separator: thousandSeparator
    }
  } = staticProps;
  const intFraction = getFormattedIntFraction(price.original_value, thousandSeparator);
  const priceProps = _objectSpread({
    price: _objectSpread(_objectSpread({}, price), {}, {
      original_value: null
    })
  }, props);
  return /*#__PURE__*/_jsx("div", {
    className: "ui-pdp-kits-price"
  }, void 0, Object.keys(current_price_label).length > 0 && (price === null || price === void 0 ? void 0 : price.original_value) && /*#__PURE__*/_jsx("div", {
    className: "ui-pdp-price-discount"
  }, void 0, /*#__PURE__*/React.createElement(StyledLabel, current_price_label), /*#__PURE__*/_jsx(MoneyAmount, {
    previous: true,
    symbol: price.currency_symbol,
    size: 14,
    value: {
      fraction: intFraction
    }
  })), /*#__PURE__*/_jsx("div", {
    className: "ui-pdp-price-total"
  }, void 0, /*#__PURE__*/React.createElement(StyledLabel, _extends({}, total_price_label, {
    className: "ui-pdp-price-total__text"
  })), /*#__PURE__*/React.createElement(PriceDesktop, _extends({
    meta: true,
    num_font_size: 18
  }, jsonToProps(priceProps)))));
};
const KitsWrapperDesktop = _ref => {
  let {
    components = [],
    className = '',
    viewport_track = null
  } = _ref;
  const refView = useTrackView(viewport_track, {
    threshold: 0.1
  });
  const getComponentProps = id => components.find(component => component.id === id) || {};
  return /*#__PURE__*/React.createElement("div", {
    ref: refView,
    className: classnames('ui-pdp-kits ui-pdp-kits--desktop', className)
  }, components.map(component => {
    if (component.id === 'kits_list') {
      const priceProps = getComponentProps('kits_price');
      return /*#__PURE__*/React.createElement(KitsListDesktop, _extends({
        key: component.id
      }, component), /*#__PURE__*/React.createElement(KitsPriceDesktop, priceProps));
    }
    return null;
  }));
};
const componentMap = {
  kits_price: KitsPriceMobile,
  kits_list: KitsListMobile
};
const KitsWrapperMobile = _ref => {
  let {
    components = [],
    className = '',
    viewport_track = null
  } = _ref;
  const refView = useTrackView(viewport_track, {
    threshold: 0.1
  });
  const getComponent = component => {
    const Component = componentMap[component.id];
    return Component && /*#__PURE__*/React.createElement(Component, component);
  };
  return /*#__PURE__*/React.createElement("div", {
    ref: refView,
    className: classnames('ui-pdp-kits ui-pdp-kits--mobile', className)
  }, components.map(component => getComponent(component)));
};
export { KitsListDesktop, KitsListMobile, KitsPriceDesktop, KitsPriceMobile, KitsWrapperDesktop, KitsWrapperMobile };
